var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGameCategoryNonstop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4233.32 4233.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor",
      fillRule: "nonzero"
    },
    d: "M1859.12 2575.3l-375.74 -375.74 -186.93 187.01 560.94 560.94 1058.35 -1058.35 -187.01 -187 -869.61 873.14 0 0zm257.54 964.88c-681.74,-0.06 -1234.69,-553.01 -1234.69,-1234.81 0,-681.75 552.95,-1234.69 1234.69,-1234.69 681.81,0 1234.75,552.94 1234.75,1234.69 0,681.8 -552.94,1234.75 -1234.75,1234.75l0 0.06zm0 -2822.3c-876.55,0 -1587.49,710.94 -1587.49,1587.49 0,876.61 710.94,1587.55 1587.49,1587.55 876.61,0 1587.55,-710.94 1587.55,-1587.55 0,-876.55 -710.94,-1587.49 -1587.55,-1587.49l0 0zm-726.75 -107.6l-225.8 -269.87 -811.34 679.14 227.53 269.87 809.61 -679.14 0 0zm2490.64 411l-811.35 -680.87 -227.6 269.87 811.41 680.87 227.54 -269.87z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameCategoryNonstop);
export default __webpack_public_path__ + "static/media/icon-game-category-nonstop.da783b7678defe6491c16e44800f0c0c.svg";
export { ForwardRef as ReactComponent };